import axios from "axios";
import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";
import { toastShow } from "../../../Base/Services/ToastService";

// OBTENER PROVEEDORES PARA SCREEN
export const getCustomers = async () => {
  const respuesta = await PrivateInterceptor(`Compras/Customers`, "GET");
  return respuesta;
};

// OBTENER PROVEEDORES PARA SCREEN
export const getCustomersAct = async () => {
  const respuesta = await PrivateInterceptor(`Compras/Customers/Activos`, "GET");
  return respuesta;
};

// AGREGAR O EDITAR CUSTOMER
export const addCustomers = async (data) => {
  const respuesta = await PrivateInterceptor(`Compras/Customers/add`, "POST", data);
  return respuesta;
};

export const updateEnlaceInscripcion = async (body) => {
  const result = await PrivateInterceptor(`Compras/Customers/actualizarEstadoEdicion`, 'PUT', body);
  return result;
}

export const sendEmailInscripcion = async(objeto, Token) =>{
  const result = await PublicInterceptor('Compras/Customers/enviarEmail', 'POST', objeto, Token)
  return result
}

export const getEnlaceInscripcion = async (IdCustomer, IdUser) => {
  const result = await PrivateInterceptor(`Compras/Customers/LinkInscripcion`, 'POST', {IdCustomer, IdUser});
  return result;
}

export const getClientePorId = async (IdCustomer, Token) => {
  const result = await PublicInterceptor(`Compras/Customers/ClientePorId`, 'POST', {IdCustomer}, Token);
  return result;
}

export const getTipoPago = async(Token) => {
  const result = await PublicInterceptor('Compras/Customers/TipoPagos', 'GET', {}, Token)
  return result;
}

export const getAccionistas = async (IdCustomer, token) => {
  const result = await PublicInterceptor(`Compras/Customers/getAccionistas`, 'POST', {IdCustomer}, token );
  return result;
}

export const getDirectores = async (IdCustomer, token) => {
  const result = await PublicInterceptor(`Compras/Customers/getDirectores`, 'POST', {IdCustomer}, token );
  return result;
}

export const GuardarInscripcion = (Datos, token) => {
  const respuesta = PublicInterceptor("Compras/Customers/AgregarCustomerInfo", "POST", {Datos}, token);
  return respuesta;
};

export const GuardarAccionistas = (Datos, token) => {
  const respuesta = PublicInterceptor("Compras/Customers/AgregarAccionista", "POST", {Datos}, token);
  return respuesta;
};

export const GuardarDirectores = (Datos, token) => {
  const respuesta = PublicInterceptor("Compras/Customers/AgregarDirector", "POST", {Datos}, token);
  return respuesta;
};


export const postChangeEstadoClientes = async (data) => {
  const result = await PrivateInterceptor(`Compras/Customers/chageEstadoClientes`, 'POST', data);
  return result;
}


// -----------------------------------------ARCHIVOS-----------------------------------------

export const getArchivo = async(Codigo, Token, url) => {
  const respuesta = await PublicInterceptor(`Compras/Customers/${url}/` + Codigo, 'GET', {}, Token)
  return respuesta;
}

export const uploadFile = ({ e, inputs, toast, ref, url, getArchivos = () => { }, Token }) => {
  for (let i = 0; i < e.files.length; i++) {
    var formData = new FormData();
    formData.append('file', e.files[i]);

    inputs.forEach(input => {
      formData.append(input.name, input.value);
    })
    let urlFinal = `${process.env.REACT_APP_API_URL}/Compras/Customers/${url}/upload?${Date.now()}`
    axios.post(urlFinal, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),
      }
    }).then(res => {
      if (toast) {
        toastShow(toast, 'success', 'Agregado', 'Archivo Agregado')
      }
      ref.current.clear();
      getArchivos()
    }).catch(err => {
      if (toast) {
        toastShow(toast, 'error', 'Error','Error al subir el archivo')
      }
    })
  }
}

export const descargarArchivo = async (Codigo, nombre, Token, url) => {
  const respuesta = await PublicInterceptor(`Compras/Customers/${url}/descargar/${Codigo}`, 'POST', {nombre}, Token)
  return respuesta;
}

export const descargarArchivoPrivate = async (Codigo, nombre, url) => {
  const respuesta = await PrivateInterceptor(`Compras/Customers/${url}/descargar/${Codigo}`, 'POST', {nombre})
  return respuesta;
}

export const eliminarArchivo = async (Codigo, nombre, Token, url) => {
  const respuesta = await PublicInterceptor(`Compras/Customers/${url}/deleteFile/${Codigo}`, 'DELETE', {nombre}, Token)
  return respuesta;
}

export const getArchivoRefComercial1 = async(Codigo, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Customers/Representante/` + Codigo, 'GET', {}, Token)
  return respuesta;
}

export const descargarManual = async (nombre, Token) => {
  const respuesta = await PublicInterceptor(`Compras/Customers/ManualIns/descargar`, 'POST', {nombre}, Token)
  return respuesta;
}